// import React, { useEffect, useState } from "react";
// import { useOutletContext } from "react-router-dom";
// import {
//   FaMoneyBillWave,
//   FaCheckCircle,
//   FaDollarSign,
//   FaClipboardCheck,
//   FaLock,
// } from "react-icons/fa";
// import { HiOutlinePhone } from "react-icons/hi";
// import { AiOutlineMail, AiOutlineCalendar } from "react-icons/ai";
// import { ImLocation2 } from "react-icons/im";
// import ChangePasswordModal from "./ChangePassword/ServitorChangePassword";

// import "./ServitorProfile.css";

// const ServitorProfile = () => {
//   const { servitor } = useOutletContext();

//   const [metrics, setMetrics] = useState({
//     totalIncome: 0,
//     totalAcceptedOrders: 0,
//     totalCompletedOrders: 0,
//   });

//   const [showPasswordModal, setShowPasswordModal] = useState(false);

//   // Fetch metrics for accepted orders count
//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       fetch(`http://localhost:4001/servitor-dashboard-metrics/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((metricsData) => {
//           setMetrics(metricsData);
//         })
//         .catch((err) => console.error("Error fetching metrics:", err));
//     }
//   }, [servitor]);

//   const togglePasswordModal = () => {
//     setShowPasswordModal((prev) => !prev);
//   };

//   // Safely extract servitor fields with fallbacks
//   const name = `${servitor?.FirstName || ""} ${
//     servitor?.LastName || ""
//   }`.trim();
//   const service = servitor?.service || "";
//   const status = servitor?.approve_status || "Pending";
//   const available = servitor?.availability || "busy";
//   const location = servitor?.city || "Unknown Location";
//   const address = servitor?.Address || "Unknown Address";
//   const rating = servitor?.rating || 0;
//   const reviewsCount = servitor?.rating_count || 0;
//   const balance = servitor?.balance || 0;
//   const completedJobs = servitor?.orders_completed || 0;
//   const totalIncome = servitor?.total_earnings || 0;
//   const acceptedOrders = metrics.totalAcceptedOrders || 0;
//   const targetOrders = 10;
//   // Calculate completion rate as percentage of the target, capping at 100%
//   const completionRate =
//     completedJobs > 0
//       ? Math.min((completedJobs / targetOrders) * 100, 100).toFixed(0)
//       : 0;
//   // const responseTime = servitor?.responseTime || "~2 hours";
//   const mobile = servitor?.mobile || "N/A";
//   const email = servitor?.email || "N/A";
//   //   const joinedDate = servitor?.created_at || "January 2024";
//   const joinedDate = servitor?.created_at
//     ? new Date(servitor.created_at).toLocaleDateString("en-GB", {
//         day: "2-digit",
//         month: "long",
//         year: "numeric",
//       })
//     : "January 2024";

//   //   const servicesOffered = servitor?.services || [
//   //     { name: "Home Cleaning", price: 200 },
//   //     { name: "Deep Cleaning", price: 350 },
//   //     { name: "Office Cleaning", price: 400 },
//   //   ];

//   return (
//     <div className="servitorprofile-wrapper">
//       <div className="servitorprofile-card">
//         {/* Top Section with Avatar, Name, Status, Location */}
//         <div className="servitorprofile-top-section">
//           <img
//             className="servitorprofile-avatar"
//             src={
//               servitor?.image
//                 ? `http://localhost:4001/uploads/${servitor.image}`
//                 : "https://via.placeholder.com/150"
//             }
//             alt="Profile"
//           />
//           <h2 className="servitorprofile-name">{name}</h2>
//           <p>Professional on {service} service</p>

//           <div className="servitorprofile-status-row">
//             <span
//               className={`servitorprofile-status-badge servitorprofile-status-${status.toLowerCase()}`}
//             >
//               {/* {status} */}
//               <i
//                 className={`fas ${
//                   status === "Approved"
//                     ? "fa-check-circle"
//                     : status === "Blocked"
//                     ? "bx bxs-error-alt"
//                     : "fa-hourglass-half"
//                 }`}
//               ></i>{" "}
//               {status}
//             </span>
//             <span className="servitorprofile-location">
//               {/* {location} */}
//               <i className="fas fa-map-marker-alt"></i> {location}
//             </span>

//             <span
//               className={`servitorprofile-status-badge servitorprofile-available-${available.toLowerCase()}`}
//             >
//               <i
//                 className={`fas ${
//                   available === "available" ? "fa-user-check" : "fa-user-clock"
//                 }`}
//               ></i>{" "}
//               {available}
//             </span>
//           </div>

//           <div className="servitorprofile-rating-row">
//             <div className="servitorprofile-rating">
//               <span className="servitorprofile-rating-stars">★</span>
//               <span className="servitorprofile-rating-value">
//                 {rating.toFixed(1)}
//               </span>
//               <span className="servitorprofile-reviews-count">
//                 ({reviewsCount} reviews)
//               </span>
//             </div>
//             <div className="servitorprofile-completion-rate">
//               {/* <i className="fas fa-chart-line"></i> {completionRate}% Completion Rate */}
//               {completionRate}% Completion Rate
//             </div>
//           </div>
//         </div>

//         {/* MIDDLE SECTION (Cards + Contact Info) */}
//         <div className="servitorprofile-middle-container">
//           {/* Stats Cards Row */}
//           <div className="servitorprofile-cards-row">
//             <div className="servitorprofile-card-box">
//               <div className="card-box-icon">
//                 <FaMoneyBillWave />
//               </div>
//               <p className="card-box-value">{balance.toLocaleString()} Tk</p>
//               <p className="card-box-label">Balance</p>
//             </div>

//             <div className="servitorprofile-card-box">
//               <div className="card-box-icon">
//                 <FaCheckCircle />
//               </div>
//               <p className="card-box-value">{completedJobs}</p>
//               <p className="card-box-label">Completed Jobs</p>
//             </div>

//             <div className="servitorprofile-card-box">
//               <div className="card-box-icon">
//                 <FaDollarSign />
//               </div>
//               <p className="card-box-value">
//                 {totalIncome.toLocaleString()} Tk
//               </p>
//               <p className="card-box-label">Total Income</p>
//             </div>

//             <div className="servitorprofile-card-box">
//               <div className="card-box-icon">
//                 <FaClipboardCheck />
//               </div>
//               <p className="card-box-value">{acceptedOrders}</p>
//               <p className="card-box-label">Accepted Orders</p>
//             </div>
//           </div>

//           {/* Contact Info Card */}
//           <div className="servitorprofile-contact-card">
//             <h3>Contact Information</h3>
//             <div className="contact-info-grid">
//               <div className="contact-info-item">
//                 <HiOutlinePhone className="contact-icon" />
//                 <div className="contact-info-text">
//                   <span className="contact-info-label">Phone</span>
//                   <span className="contact-info-value">{mobile}</span>
//                 </div>
//               </div>
//               <div className="contact-info-item">
//                 <AiOutlineMail className="contact-icon" />
//                 <div className="contact-info-text">
//                   <span className="contact-info-label">Email</span>
//                   <span className="contact-info-value">{email}</span>
//                 </div>
//               </div>
//               <div className="contact-info-item">
//                 <ImLocation2 className="contact-icon" />
//                 <div className="contact-info-text">
//                   <span className="contact-info-label">Location</span>
//                   <span className="contact-info-value">{address}</span>
//                 </div>
//               </div>
//               <div className="contact-info-item">
//                 <AiOutlineCalendar className="contact-icon" />
//                 <div className="contact-info-text">
//                   <span className="contact-info-label">Member since</span>
//                   <span className="contact-info-value">{joinedDate}</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Action Buttons */}
//         <div className="servitorprofile-actions">
//           {/* <button className="servitorprofile-btn">Edit Profile</button> */}
//           <button
//             className="servitorprofile-btn servitorprofile-btn-secondary"
//             onClick={togglePasswordModal}
//           >
//             <FaLock style={{ marginRight: "8px" }} />
//             Change Password
//           </button>
//         </div>
//       </div>

//       <ChangePasswordModal
//         isOpen={showPasswordModal}
//         onClose={togglePasswordModal}
//         servitorId={servitor?.Id}
//       />
//     </div>
//   );
// };

// export default ServitorProfile;

// ***** Upper code All checked and okay (26-6-25) ***** //

// ***** Add Translate EN BN and updated (26-6-25) ***** //
// import React, { useEffect, useState } from "react";
// import { useOutletContext } from "react-router-dom";
// import {
//   FaMoneyBillWave,
//   FaCheckCircle,
//   FaDollarSign,
//   FaClipboardCheck,
//   FaLock,
// } from "react-icons/fa";
// import { HiOutlinePhone } from "react-icons/hi";
// import { AiOutlineMail, AiOutlineCalendar } from "react-icons/ai";
// import { ImLocation2 } from "react-icons/im";
// import { useTranslation } from "react-i18next";
// import ChangePasswordModal from "./ChangePassword/ServitorChangePassword";
// import BalanceRecharge from "./Balance/BalanceRecharge";
// import "./ServitorProfile.css";

// const ServitorProfile = () => {
//   const { t } = useTranslation("servitor");
//   const { servitor } = useOutletContext();

//   const [metrics, setMetrics] = useState({
//     totalIncome: 0,
//     totalAcceptedOrders: 0,
//     totalCompletedOrders: 0,
//   });

//   const [showPasswordModal, setShowPasswordModal] = useState(false);
//   const [showBalanceModal, setShowBalanceModal] = useState(false); //new added for balance view

//   // Fetch metrics for accepted orders count
//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       fetch(`http://localhost:4001/servitor-dashboard-metrics/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((metricsData) => {
//           setMetrics(metricsData);
//         })
//         .catch((err) => console.error("Error fetching metrics:", err));
//     }
//   }, [servitor]);

//   // NEW: Listen for custom event to open balance modal
//   useEffect(() => {
//     const openModal = () => setShowBalanceModal(true);
//     document.addEventListener("openBalanceModal", openModal);
//     return () => document.removeEventListener("openBalanceModal", openModal);
//   }, []);

//   const togglePasswordModal = () => {
//     setShowPasswordModal((prev) => !prev);
//   };

//   // NEW: Function to toggle balance modal
//   const toggleBalanceModal = () => {
//     setShowBalanceModal((prev) => !prev);
//   };

//   // Safely extract servitor fields with fallbacks
//   const name = `${servitor?.FirstName || ""} ${
//     servitor?.LastName || ""
//   }`.trim();
//   // UPDATED: Normalize service value and add debugging for translation
//   const rawService = servitor?.service ? servitor.service.toLowerCase() : null;

//   // const service = servitor?.service || "";
//   console.log(
//     "servitor.service:",
//     servitor?.service,
//     "normalized:",
//     rawService
//   );
//   const service = rawService
//     ? t(`viewOrderDetails.services.${rawService}.title`, {
//         defaultValue: t("servitorProfile.unknownService"),
//       }) // NEW: Translate service using viewOrderDetails.services with fallback to unknownService
//     : t("servitorProfile.unknownService");

//   // const status = servitor?.approve_status || "Pending";
//   // const available = servitor?.availability || "busy";
//   // const location = servitor?.city || "Unknown Location";
//   // const address = servitor?.Address || "Unknown Address";

//   const status = servitor?.approve_status || "Pending";
//   const available = servitor?.availability || "busy";
//   const location = servitor?.city
//     ? t(`servitorSite.cities.${servitor.city}`, {
//         defaultValue: t("servitorProfile.unknownLocation"),
//       })
//     : t("servitorProfile.unknownLocation");
//   const address = servitor?.Address || t("servitorProfile.unknownAddress");

//   const rating = servitor?.rating || 0;
//   const reviewsCount = servitor?.rating_count || 0;
//   const balance = servitor?.balance || 0;
//   const completedJobs = servitor?.orders_completed || 0;
//   const totalIncome = servitor?.total_earnings || 0;
//   const acceptedOrders = metrics.totalAcceptedOrders || 0;
//   const targetOrders = 10;
//   // Calculate completion rate as percentage of the target, capping at 100%
//   const completionRate =
//     completedJobs > 0
//       ? Math.min((completedJobs / targetOrders) * 100, 100).toFixed(0)
//       : 0;
//   // const responseTime = servitor?.responseTime || "~2 hours";
//   const mobile = servitor?.mobile || "N/A";
//   const email = servitor?.email || "N/A";
//   //   const joinedDate = servitor?.created_at || "January 2024";

//   // const joinedDate = servitor?.created_at
//   //   ? new Date(servitor.created_at).toLocaleDateString("en-GB", {
//   //       day: "2-digit",
//   //       month: "long",
//   //       year: "numeric",
//   //     })
//   //   : "January 2024";

//   const locale = t("common.locale", { defaultValue: "en-GB" }); // NEW: Get locale from translations
//   const validLocales = ["en-GB", "bn-BD"];
//   const safeLocale = validLocales.includes(locale) ? locale : "en-GB"; // NEW: Ensure valid locale
//   const joinedDate = servitor?.created_at
//     ? new Date(servitor.created_at).toLocaleDateString(safeLocale, {
//         day: "2-digit",
//         month: "long",
//         year: "numeric",
//       })
//     : t("servitorProfile.defaultJoinDate");

//   //   const servicesOffered = servitor?.services || [
//   //     { name: "Home Cleaning", price: 200 },
//   //     { name: "Deep Cleaning", price: 350 },
//   //     { name: "Office Cleaning", price: 400 },
//   //   ];

//   return (
//     <div className="servitorprofile-wrapper">
//       <div className="servitorprofile-card">
//         {/* Top Section with Avatar, Name, Status, Location */}
//         <div className="servitorprofile-top-section">
//           <img
//             className="servitorprofile-avatar"
//             src={
//               servitor?.image
//                 ? `http://localhost:4001/uploads/${servitor.image}`
//                 : "https://via.placeholder.com/150"
//             }
//             alt="Profile"
//           />
//           <h2 className="servitorprofile-name">{name}</h2>
//           {/* <p>Professional on {service} service</p> */}
//           <p>{t("servitorProfile.professionalOnService", { service })}</p>

//           <div className="servitorprofile-status-row">
//             <span
//               className={`servitorprofile-status-badge servitorprofile-status-${status.toLowerCase()}`}
//               aria-label={t(`status.${status.toLowerCase()}`, {
//                 defaultValue: status,
//               })}
//             >
//               {/* {status} */}
//               <i
//                 className={`fas ${
//                   status === "Approved"
//                     ? "fa-check-circle"
//                     : status === "Blocked"
//                     ? "bx bxs-error-alt"
//                     : "fa-hourglass-half"
//                 }`}
//               ></i>{" "}
//               {/* {status} */}
//               {t(`status.${status.toLowerCase()}`, { defaultValue: status })}
//             </span>
//             <span className="servitorprofile-location">
//               {/* {location} */}
//               <i className="fas fa-map-marker-alt"></i> {location}
//             </span>

//             <span
//               className={`servitorprofile-status-badge servitorprofile-available-${available.toLowerCase()}`}
//               aria-label={t(`status.${available.toLowerCase()}`, {
//                 defaultValue: available,
//               })}
//             >
//               <i
//                 className={`fas ${
//                   available === "available" ? "fa-user-check" : "fa-user-clock"
//                 }`}
//               ></i>{" "}
//               {/* {available} */}
//               {t(`status.${available.toLowerCase()}`, {
//                 defaultValue: available,
//               })}
//             </span>
//           </div>

//           <div className="servitorprofile-rating-row">
//             <div className="servitorprofile-rating">
//               <span className="servitorprofile-rating-stars">★</span>
//               <span className="servitorprofile-rating-value">
//                 {rating.toFixed(1)}
//               </span>
//               <span className="servitorprofile-reviews-count">
//                 {/* ({reviewsCount} reviews) */}
//                 {t("servitorProfile.reviews", { count: reviewsCount })}
//               </span>
//             </div>
//             <div className="servitorprofile-completion-rate">
//               {/* <i className="fas fa-chart-line"></i> {completionRate}% Completion Rate */}
//               {/* {completionRate}% Completion Rate */}
//               {t("servitorProfile.completionRate", { rate: completionRate })}
//             </div>
//           </div>
//         </div>

//         {/* MIDDLE SECTION (Cards + Contact Info) */}
//         <div className="servitorprofile-middle-container">
//           {/* Stats Cards Row */}
//           <div className="servitorprofile-cards-row">
//             <div className="servitorprofile-card-box">
//               <div className="card-box-icon">
//                 <FaMoneyBillWave />
//               </div>
//               <p className="card-box-value">{balance.toLocaleString()} Tk</p>
//               {/* <p className="card-box-label">Balance</p> */}
//               <p className="card-box-label">{t("servitorProfile.balance")}</p>
//             </div>

//             <div className="servitorprofile-card-box">
//               <div className="card-box-icon">
//                 <FaCheckCircle />
//               </div>
//               <p className="card-box-value">{completedJobs}</p>
//               {/* <p className="card-box-label">Completed Jobs</p> */}
//               <p className="card-box-label">
//                 {t("servitorProfile.completedJobs")}
//               </p>
//             </div>

//             <div className="servitorprofile-card-box">
//               <div className="card-box-icon">
//                 <FaDollarSign />
//               </div>
//               <p className="card-box-value">
//                 {totalIncome.toLocaleString()} Tk
//               </p>
//               {/* <p className="card-box-label">Total Income</p> */}
//               <p className="card-box-label">
//                 {t("servitorProfile.totalIncome")}
//               </p>
//             </div>

//             <div className="servitorprofile-card-box">
//               <div className="card-box-icon">
//                 <FaClipboardCheck />
//               </div>
//               <p className="card-box-value">{acceptedOrders}</p>
//               {/* <p className="card-box-label">Accepted Orders</p> */}
//               <p className="card-box-label">
//                 {t("servitorProfile.acceptedOrders")}
//               </p>
//             </div>
//           </div>

//           {/* Contact Info Card */}
//           <div className="servitorprofile-contact-card">
//             {/* <h3>Contact Information</h3> */}
//             <h3>{t("servitorProfile.contactInformation")}</h3>
//             <div className="contact-info-grid">
//               <div className="contact-info-item">
//                 <HiOutlinePhone className="contact-icon" />
//                 <div className="contact-info-text">
//                   {/* <span className="contact-info-label">Phone</span> */}
//                   <span className="contact-info-label">
//                     {t("servitorProfile.phone")}
//                   </span>
//                   <span className="contact-info-value">{mobile}</span>
//                 </div>
//               </div>
//               <div className="contact-info-item">
//                 <AiOutlineMail className="contact-icon" />
//                 <div className="contact-info-text">
//                   {/* <span className="contact-info-label">Email</span> */}
//                   <span className="contact-info-label">
//                     {t("servitorProfile.email")}
//                   </span>
//                   <span className="contact-info-value">{email}</span>
//                 </div>
//               </div>
//               <div className="contact-info-item">
//                 <ImLocation2 className="contact-icon" />
//                 <div className="contact-info-text">
//                   {/* <span className="contact-info-label">Location</span> */}
//                   <span className="contact-info-label">
//                     {t("servitorProfile.location")}
//                   </span>
//                   <span className="contact-info-value">{address}</span>
//                 </div>
//               </div>
//               <div className="contact-info-item">
//                 <AiOutlineCalendar className="contact-icon" />
//                 <div className="contact-info-text">
//                   {/* <span className="contact-info-label">Member since</span> */}
//                   <span className="contact-info-label">
//                     {t("servitorProfile.memberSince")}
//                   </span>
//                   <span className="contact-info-value">{joinedDate}</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Action Buttons */}
//         <div className="servitorprofile-actions">
//           {/* <button className="servitorprofile-btn">Edit Profile</button> */}

//           {/* NEW: Added Recharge Balance button */}
//           <button
//             className="servitorprofile-btn"
//             onClick={toggleBalanceModal}
//             aria-label={t("balanceRecharge.title")}
//           >
//             <FaMoneyBillWave style={{ marginRight: "8px" }} />
//             {t("balanceRecharge.title")}
//           </button>

//           <button
//             className="servitorprofile-btn servitorprofile-btn-secondary"
//             onClick={togglePasswordModal}
//             aria-label={t("servitorProfile.changePassword")}
//           >
//             <FaLock style={{ marginRight: "8px" }} />
//             {/* Change Password */}
//             {t("servitorProfile.changePassword")}
//           </button>
//         </div>
//       </div>

//       <ChangePasswordModal
//         isOpen={showPasswordModal}
//         onClose={togglePasswordModal}
//         servitorId={servitor?.Id}
//       />

//       {/* NEW: Added Balance Recharge Modal */}
//       <BalanceRecharge
//         isOpen={showBalanceModal}
//         onClose={toggleBalanceModal}
//         servitorId={servitor?.Id}
//         currentBalance={servitor?.balance || 0}
//       />
//     </div>
//   );
// };

// export default ServitorProfile;

// ***** New Update with toast (2-7-25) ***** //
// import React, { useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
// import toast, { Toaster } from "react-hot-toast";
// import {
//   FaMoneyBillWave,
//   FaCheckCircle,
//   // FaDollarSign,
//   FaClipboardCheck,
//   FaLock,
//   FaCheck,
//   FaExclamationTriangle,
//   FaTimesCircle,
//   FaIdCard,
//   FaBriefcase,
// } from "react-icons/fa";
// import { HiOutlinePhone } from "react-icons/hi";
// import { AiOutlineMail, AiOutlineCalendar } from "react-icons/ai";
// import { ImLocation2 } from "react-icons/im";
// import { useTranslation } from "react-i18next";
// import ChangePasswordModal from "./ChangePassword/ServitorChangePassword";
// import BalanceRecharge from "./Balance/BalanceRecharge";
// import "./ServitorProfile.css";
// import ProfessionalBio from "./ProfessionalBio";

// const ServitorProfile = () => {
//   const { search, pathname } = useLocation();
//   const navigate = useNavigate();

//   const { t } = useTranslation("servitor");
//   const { servitor } = useOutletContext();

//   const [metrics, setMetrics] = useState({
//     totalIncome: 0,
//     totalAcceptedOrders: 0,
//     totalCompletedOrders: 0,
//   });

//   const [rewards, setRewards] = useState({
//     rewardPoints: 0,
//     lifetimeRewardPoints: 0,
//     canClaim: false,
//     threshold: 100
//   });
//   const [claimLoading, setClaimLoading] = useState(false);

//   const [showPasswordModal, setShowPasswordModal] = useState(false);
//   const [showBalanceModal, setShowBalanceModal] = useState(false); //new added for balance view

//   // NEW: Added useRef to track whether toast has been shown to prevent duplicates
//   const hasShownToast = useRef(false);

//   // NEW: Custom toast component with progress bar for styled notifications
//   const showCustomToast = (message, type, icon) => {
//     toast.custom(
//       (t) => (
//         <div
//           className={`custom-toast custom-toast-${type} ${
//             t.visible ? "slide-in" : "slide-out"
//           }`}
//         >
//           <div className="toast-content">
//             <span className="toast-icon">{icon}</span>
//             <span className="toast-message">{message}</span>
//           </div>
//           <div
//             className="toast-progress"
//             style={{
//               animation: "progress 3s linear forwards", // NEW: Changed from 5s to 3s to match requirement
//             }}
//           />
//         </div>
//       ),
//       {
//         duration: 3000, // NEW: Set to 3 seconds as per requirement (was 5000 in previous version)
//         position: "top-right", // NEW: Position toasts at top-right
//       }
//     );
//   };

//   // NEW: Handle query parameters for payment status to show toasts
//   useEffect(() => {
//     const params = new URLSearchParams(search);
//     const status = params.get("status");
//     const amount = params.get("amount");

//     if (!status || hasShownToast.current) return; // NEW: Prevent duplicate toasts using hasShownToast

//     hasShownToast.current = true; // NEW: Mark toast as shown

//     switch (status) {
//       case "success":
//         showCustomToast(
//           t("balanceRecharge.toastSuccess", { amount }),
//           "success",
//           <FaCheck />
//         );
//         break;
//       case "success-risk":
//         showCustomToast(t("balanceRecharge.toastRisk"), "warning", <FaExclamationTriangle />);
//         break;
//       case "cancelled":
//         showCustomToast(t("balanceRecharge.toastCancelled"), "error", <FaTimesCircle />);
//         break;
//       case "failed":
//         showCustomToast(t("balanceRecharge.toastFailed"), "error", <FaTimesCircle />);
//         break;
//       default:
//         showCustomToast(t("balanceRecharge.toastError"), "error", <FaTimesCircle />);
//     }

//     // NEW: Clear query parameters to prevent toast re-firing on refresh
//     params.delete("status");
//     params.delete("amount");
//     navigate({ pathname, search: params.toString() }, { replace: true });
//   }, [search, pathname, navigate, t]);

//   // Fetch metrics for accepted orders count
//   useEffect(() => {
//     if (servitor && servitor.Id) {
//       fetch(`http://localhost:4001/servitor-dashboard-metrics/${servitor.Id}`)
//         .then((res) => res.json())
//         .then((metricsData) => {
//           setMetrics(metricsData);
//         })
//         .catch((err) => console.error("Error fetching metrics:", err));

//         fetch(`http://localhost:4001/rewards/servitors/${servitor.Id}/summary`)
//         .then((res) => res.json())
//         .then((data) => {
//           if (data && data.rewardPoints !== undefined) {
//             setRewards({
//               rewardPoints: data.rewardPoints,
//               lifetimeRewardPoints: data.lifetimeRewardPoints,
//               canClaim: data.canClaim,
//               threshold: data.threshold
//             });
//          }
//         })
//         .catch((err) => console.error("Error fetching rewards:", err));
//     }
//   }, [servitor]);

//   // NEW: Listen for custom event to open balance modal
//   useEffect(() => {
//     const openModal = () => setShowBalanceModal(true);
//     document.addEventListener("openBalanceModal", openModal);
//     return () => document.removeEventListener("openBalanceModal", openModal);
//   }, []);

//   const togglePasswordModal = () => {
//     setShowPasswordModal((prev) => !prev);
//   };

//   // NEW: Function to toggle balance modal
//   const toggleBalanceModal = () => {
//     setShowBalanceModal((prev) => !prev);
//   };

//   // Safely extract servitor fields with fallbacks
//   const name = `${servitor?.FirstName || ""} ${
//     servitor?.LastName || ""
//   }`.trim();

//   const SERVICE_KEY_MAP = {
//   plumber:         "plumber",
//   electrician:     "electrician",
//   "home cleaning": "homeCleaning",
// };
//   // UPDATED: Normalize service value and add debugging for translation
//   // const rawService = servitor?.service ? servitor.service.toLowerCase() : null;

//   // // const service = servitor?.service || "";
//   // console.log(
//   //   "servitor.service:",
//   //   servitor?.service,
//   //   "normalized:",
//   //   rawService
//   // );
//   // const service = rawService
//   //   ? t(`viewOrderDetails.services.${rawService}.title`, {
//   //       defaultValue: t("servitorProfile.unknownService"),
//   //     }) // NEW: Translate service using viewOrderDetails.services with fallback to unknownService
//   //   : t("servitorProfile.unknownService");

//   // UPDATED: Normalize service value and add debugging for translation
//   const rawService = servitor?.service ? servitor.service.toLowerCase() : null;
//   // 2) map it to the JSON key (e.g. "home cleaning" → "homeCleaning")
//   const serviceKey = rawService ? SERVICE_KEY_MAP[rawService] : null;

//   let service;
//   if (serviceKey) {
//     // 3) look up the translated title, e.g. "Plumber Details"
//     const fullTitle = t(
//       `viewOrderDetails.services.${serviceKey}.title`,
//       { defaultValue: t("servitorProfile.unknownService") }
//     );
//     // 4) strip any trailing " Details"
//     service = fullTitle.replace(/\s*Details$/, "");
//   } else {
//     // fallback if we don’t recognize the string
//     service = t("servitorProfile.unknownService");
//   }

//   // const status = servitor?.approve_status || "Pending";
//   // const available = servitor?.availability || "busy";
//   // const location = servitor?.city || "Unknown Location";
//   // const address = servitor?.Address || "Unknown Address";

//   const status = servitor?.approve_status || "Pending";
//   const available = servitor?.availability || "busy";
//   const location = servitor?.city
//     ? t(`servitorSite.cities.${servitor.city}`, {
//         defaultValue: t("servitorProfile.unknownLocation"),
//       })
//     : t("servitorProfile.unknownLocation");
//   const address = servitor?.Address || t("servitorProfile.unknownAddress");

//   const rating = servitor?.rating || 0;
//   const reviewsCount = servitor?.rating_count || 0;
//   const balance = servitor?.balance || 0;
//   const completedJobs = servitor?.orders_completed || 0;
//   const totalIncome = servitor?.total_earnings || 0;
//   const acceptedOrders = metrics.totalAcceptedOrders || 0;
//   const targetOrders = 10;
//   // Calculate completion rate as percentage of the target, capping at 100%
//   const completionRate =
//     completedJobs > 0
//       ? Math.min((completedJobs / targetOrders) * 100, 100).toFixed(0)
//       : 0;
//   // const responseTime = servitor?.responseTime || "~2 hours";
//   const mobile = servitor?.mobile || "N/A";
//   const email = servitor?.email || "N/A";

//   const nid = servitor?.NID || t("servitorProfile.unknownNID", { defaultValue: "N/A" });
//   const experienceYears = servitor?.experience || t("servitorProfile.noExperience", { defaultValue: "0 years" });

//   //   const joinedDate = servitor?.created_at || "January 2024";

//   // const joinedDate = servitor?.created_at
//   //   ? new Date(servitor.created_at).toLocaleDateString("en-GB", {
//   //       day: "2-digit",
//   //       month: "long",
//   //       year: "numeric",
//   //     })
//   //   : "January 2024";

//   const locale = t("common.locale", { defaultValue: "en-GB" }); // NEW: Get locale from translations
//   const validLocales = ["en-GB", "bn-BD"];
//   const safeLocale = validLocales.includes(locale) ? locale : "en-GB"; // NEW: Ensure valid locale
//   const joinedDate = servitor?.created_at
//     ? new Date(servitor.created_at).toLocaleDateString(safeLocale, {
//         day: "2-digit",
//         month: "long",
//         year: "numeric",
//       })
//     : t("servitorProfile.defaultJoinDate");

//   //   const servicesOffered = servitor?.services || [
//   //     { name: "Home Cleaning", price: 200 },
//   //     { name: "Deep Cleaning", price: 350 },
//   //     { name: "Office Cleaning", price: 400 },
//   //   ];

//   const handleClaimRewards = async () => {
//   if (!servitor?.Id) return;
//   if (!rewards.canClaim) {
//     showCustomToast(`You need at least ${rewards.threshold} points to claim.`, "warning", <FaExclamationTriangle />);
//     return;
//   }
//   try {
//     setClaimLoading(true);
//     const res = await fetch(`http://localhost:4001/rewards/servitors/${servitor.Id}/claim`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//     });
//     const data = await res.json();
//     if (!res.ok) {
//       showCustomToast(data?.message || "Claim failed", "error", <FaTimesCircle />);
//     } else {
//       const added = data.addedTaka || rewards.rewardPoints;
//       showCustomToast(`Claimed ${added} tk from points`, "success", <FaCheck />);
//       setRewards((r) => ({ ...r, rewardPoints: 0, canClaim: false }));
//       // optionally bump balance in UI if you keep it here
//     }
//   } catch (e) {
//     console.error(e);
//     showCustomToast("Claim failed", "error", <FaTimesCircle />);
//   } finally {
//     setClaimLoading(false);
//   }
// };

//   return (
//     <>
//       <Toaster />
//       <div className="servitorprofile-wrapper">
//         <div className="servitorprofile-card">
//           {/* Top Section with Avatar, Name, Status, Location */}
//           <div className="servitorprofile-top-section">
//             <img
//               className="servitorprofile-avatar"
//               src={
//                 servitor?.image
//                   ? `http://localhost:4001/uploads/${servitor.image}`
//                   : "https://via.placeholder.com/150"
//               }
//               alt="Profile"
//             />
//             <h2 className="servitorprofile-name">{name}</h2>
//             {/* <p>Professional on {service} service</p> */}
//             <p>{t("servitorProfile.professionalOnService", { service })}</p>

//             <div className="servitorprofile-status-row">
//               <span
//                 className={`servitorprofile-status-badge servitorprofile-status-${status.toLowerCase()}`}
//                 aria-label={t(`status.${status.toLowerCase()}`, {
//                   defaultValue: status,
//                 })}
//               >
//                 {/* {status} */}
//                 <i
//                   className={`fas ${
//                     status === "Approved"
//                       ? "fa-check-circle"
//                       : status === "Blocked"
//                       ? "bx bxs-error-alt"
//                       : "fa-hourglass-half"
//                   }`}
//                 ></i>{" "}
//                 {/* {status} */}
//                 {t(`status.${status.toLowerCase()}`, { defaultValue: status })}
//               </span>
//               <span className="servitorprofile-location">
//                 {/* {location} */}
//                 <i className="fas fa-map-marker-alt"></i> {location}
//               </span>

//               <span
//                 className={`servitorprofile-status-badge servitorprofile-available-${available.toLowerCase()}`}
//                 aria-label={t(`status.${available.toLowerCase()}`, {
//                   defaultValue: available,
//                 })}
//               >
//                 <i
//                   className={`fas ${
//                     available === "available"
//                       ? "fa-user-check"
//                       : "fa-user-clock"
//                   }`}
//                 ></i>{" "}
//                 {/* {available} */}
//                 {t(`status.${available.toLowerCase()}`, {
//                   defaultValue: available,
//                 })}
//               </span>
//             </div>

//             <div className="servitorprofile-rating-row">
//               <div className="servitorprofile-rating">
//                 <span className="servitorprofile-rating-stars">★</span>
//                 <span className="servitorprofile-rating-value">
//                   {/* {rating.toFixed(1)} */}
//                   {Number(rating).toFixed(2)}
//                 </span>
//                 <span className="servitorprofile-reviews-count">
//                   {/* ({reviewsCount} reviews) */}
//                   {t("servitorProfile.reviews", { count: reviewsCount })}
//                 </span>
//               </div>
//               <div className="servitorprofile-completion-rate">
//                 {/* <i className="fas fa-chart-line"></i> {completionRate}% Completion Rate */}
//                 {/* {completionRate}% Completion Rate */}
//                 {t("servitorProfile.completionRate", { rate: completionRate })}
//               </div>
//             </div>
//           </div>

//           {/* MIDDLE SECTION (Cards + Contact Info) */}
//           <div className="servitorprofile-middle-container">
//             {/* Stats Cards Row */}
//             <div className="servitorprofile-cards-row">
//               <div className="servitorprofile-card-box">
//                 <div className="card-box-icon">
//                   <FaMoneyBillWave />
//                 </div>
//                 <p className="card-box-value">{balance.toLocaleString()} Tk</p>
//                 {/* <p className="card-box-label">Balance</p> */}
//                 <p className="card-box-label">{t("servitorProfile.balance")}</p>
//               </div>

//               <div className="servitorprofile-card-box">
//                 <div className="card-box-icon">
//                   <FaCheckCircle />
//                 </div>
//                 <p className="card-box-value">{completedJobs}</p>
//                 {/* <p className="card-box-label">Completed Jobs</p> */}
//                 <p className="card-box-label">
//                   {t("servitorProfile.completedJobs")}
//                 </p>
//               </div>

//               <div className="servitorprofile-card-box">
//                 <div className="card-box-icon">
//                   {/* <FaDollarSign /> */}
//                   <span className="taka-icon">৳</span>
//                 </div>
//                 <p className="card-box-value">
//                   {totalIncome.toLocaleString()} Tk
//                 </p>
//                 {/* <p className="card-box-label">Total Income</p> */}
//                 <p className="card-box-label">
//                   {t("servitorProfile.totalIncome")}
//                 </p>
//               </div>

//               <div className="servitorprofile-card-box">
//                 <div className="card-box-icon">
//                   <FaClipboardCheck />
//                 </div>
//                 <p className="card-box-value">{acceptedOrders}</p>
//                 {/* <p className="card-box-label">Accepted Orders</p> */}
//                 <p className="card-box-label">
//                   {t("servitorProfile.acceptedOrders")}
//                 </p>
//               </div>

//               <div className="servitorprofile-card-box">
//                 <div className="card-box-icon">
//                   <FaClipboardCheck />
//                 </div>
//                 <p className="card-box-value">{rewards.rewardPoints} pts</p>
//                 <p className="card-box-label">Reward Points</p>
//                 <button
//                   className="servitorprofile-btn"
//                   style={{ marginTop: 8 }}
//                   disabled={!rewards.canClaim || claimLoading}
//                   onClick={handleClaimRewards}
//                 >
//                   {claimLoading ? "Claiming..." : `Claim (≥ ${rewards.threshold})`}
//                 </button>
//                 <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
//                   Lifetime: {rewards.lifetimeRewardPoints} pts
//                 </div>
//               </div>
//             </div>

//             <ProfessionalBio servitor={servitor} />

//             {/* Contact Info Card */}
//             <div className="servitorprofile-contact-card">
//               {/* <h3>Contact Information</h3> */}
//               <h3>{t("servitorProfile.contactInformation")}</h3>
//               <div className="servitor-contact-info-grid">
//                 <div className="servitor-contact-info-item">
//                   <HiOutlinePhone className="servitor-contact-icon" />
//                   <div className="servitor-contact-info-text">
//                     {/* <span className="contact-info-label">Phone</span> */}
//                     <span className="servitor-contact-info-label">
//                       {t("servitorProfile.phone")}
//                     </span>
//                     <span className="servitor-contact-info-value">{mobile}</span>
//                   </div>
//                 </div>
//                 <div className="servitor-contact-info-item">
//                   <AiOutlineMail className="servitor-contact-icon" />
//                   <div className="servitor-contact-info-text">
//                     {/* <span className="contact-info-label">Email</span> */}
//                     <span className="servitor-contact-info-label">
//                       {t("servitorProfile.email")}
//                     </span>
//                     <span className="servitor-contact-info-value">{email}</span>
//                   </div>
//                 </div>

//                 <div className="servitor-contact-info-item">
//                   <FaIdCard className="servitor-contact-icon" />
//                   <div className="servitor-contact-info-text">
//                     <span className="servitor-contact-info-label">
//                       {t("servitorProfile.nid")}
//                     </span>
//                     <span className="servitor-contact-info-value">{nid}</span>
//                   </div>
//                 </div>

//                 <div className="servitor-contact-info-item">
//                   <FaBriefcase className="servitor-contact-icon" />
//                   <div className="servitor-contact-info-text">
//                     <span className="servitor-contact-info-label">
//                       {t("servitorProfile.experienceYears")}
//                     </span>
//                     <span className="servitor-contact-info-value">
//                       {experienceYears} {t("servitorProfile.years")}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="servitor-contact-info-item">
//                   <ImLocation2 className="servitor-contact-icon" />
//                   <div className="servitor-contact-info-text">
//                     {/* <span className="contact-info-label">Location</span> */}
//                     <span className="servitor-contact-info-label">
//                       {t("servitorProfile.location")}
//                     </span>
//                     <span className="servitor-contact-info-value">{address}</span>
//                   </div>
//                 </div>
//                 <div className="servitor-contact-info-item">
//                   <AiOutlineCalendar className="servitor-contact-icon" />
//                   <div className="servitor-contact-info-text">
//                     {/* <span className="contact-info-label">Member since</span> */}
//                     <span className="servitor-contact-info-label">
//                       {t("servitorProfile.memberSince")}
//                     </span>
//                     <span className="servitor-contact-info-value">{joinedDate}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div className="servitorprofile-actions">
//             {/* <button className="servitorprofile-btn">Edit Profile</button> */}

//             {/* NEW: Added Recharge Balance button */}
//             <button
//               className="servitorprofile-btn"
//               onClick={toggleBalanceModal}
//               aria-label={t("balanceRecharge.title")}
//             >
//               <FaMoneyBillWave style={{ marginRight: "8px" }} />
//               {t("balanceRecharge.title")}
//             </button>

//             <button
//               className="servitorprofile-btn servitorprofile-btn-secondary"
//               onClick={togglePasswordModal}
//               aria-label={t("servitorProfile.changePassword")}
//             >
//               <FaLock style={{ marginRight: "8px" }} />
//               {/* Change Password */}
//               {t("servitorProfile.changePassword")}
//             </button>
//           </div>
//         </div>

//         <ChangePasswordModal
//           isOpen={showPasswordModal}
//           onClose={togglePasswordModal}
//           servitorId={servitor?.Id}
//         />

//         {/* NEW: Added Balance Recharge Modal */}
//         <BalanceRecharge
//           isOpen={showBalanceModal}
//           onClose={toggleBalanceModal}
//           servitorId={servitor?.Id}
//           currentBalance={servitor?.balance || 0}
//         />
//       </div>
//     </>
//   );
// };

// export default ServitorProfile;

// ***** Add Reward points and update design (new) ***** //
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate, useOutletContext, Link } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import {
  FaMoneyBillWave,
  FaCheckCircle,
  // FaDollarSign,
  FaClipboardCheck,
  FaLock,
  FaCheck,
  FaExclamationTriangle,
  FaTimesCircle,
  FaIdCard,
  FaBriefcase,
  FaTrophy,
} from "react-icons/fa";
import { HiOutlinePhone } from "react-icons/hi";
import { AiOutlineCalendar } from "react-icons/ai";
import { ImLocation2 } from "react-icons/im";
import { useTranslation } from "react-i18next";
import ChangePasswordModal from "./ChangePassword/ServitorChangePassword";
import BalanceRecharge from "./Balance/BalanceRecharge";
import "./ServitorProfile.css";
import ProfessionalBio from "./ProfessionalBio";
import { URL } from "../../../config";

const ServitorProfile = () => {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  const { t } = useTranslation("servitor");
  // const { servitor } = useOutletContext();
  const { servitor, refreshServitor } = useOutletContext();

  // ===== BEST: silent refresh (no full reload) =====
  const didBootRefresh = useRef(false);
  const refreshingRef = useRef(false);

  // throttle to avoid spamming API when tab focus fires multiple times
  const lastRefreshAtRef = useRef(0);
  const MIN_REFRESH_GAP_MS = 1500;

  const silentRefresh = useCallback(async () => {
    if (!refreshServitor) return;

    const now = Date.now();
    if (now - lastRefreshAtRef.current < MIN_REFRESH_GAP_MS) return;

    if (refreshingRef.current) return;
    refreshingRef.current = true;
    lastRefreshAtRef.current = now;

    try {
      await refreshServitor();
    } catch (e) {
      console.error("refreshServitor failed:", e);
    } finally {
      refreshingRef.current = false;
    }
  }, [refreshServitor]);


    useEffect(() => {
    // 1) when profile opens (run once)
    if (!didBootRefresh.current) {
      didBootRefresh.current = true;
      silentRefresh();
    }

    // 2) when user returns to this tab
    const onVisibility = () => {
      if (document.visibilityState === "visible") silentRefresh();
    };

    // 3) when window gets focus
    const onFocus = () => silentRefresh();

    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("focus", onFocus);

    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", onFocus);
    };
  }, [silentRefresh]);



  const [metrics, setMetrics] = useState({
    totalIncome: 0,
    totalAcceptedOrders: 0,
    totalCompletedOrders: 0,
  });

  // const [rewards, setRewards] = useState({
  //   rewardPoints: 0,
  //   lifetimeRewardPoints: 0,
  //   canClaim: false,
  //   threshold: 100,
  // });
  // const [claimLoading, setClaimLoading] = useState(false);

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showBalanceModal, setShowBalanceModal] = useState(false); //new added for balance view

  // NEW: Added useRef to track whether toast has been shown to prevent duplicates
  const hasShownToast = useRef(false);

  // NEW: Custom toast component with progress bar for styled notifications
  const showCustomToast = (message, type, icon) => {
    toast.custom(
      (t) => (
        <div
          className={`custom-toast custom-toast-${type} ${
            t.visible ? "slide-in" : "slide-out"
          }`}
        >
          <div className="toast-content">
            <span className="toast-icon">{icon}</span>
            <span className="toast-message">{message}</span>
          </div>
          <div
            className="toast-progress"
            style={{
              animation: "progress 3s linear forwards", // NEW: Changed from 5s to 3s to match requirement
            }}
          />
        </div>
      ),
      {
        duration: 3000, // NEW: Set to 3 seconds as per requirement (was 5000 in previous version)
        position: "top-right", // NEW: Position toasts at top-right
      }
    );
  };

  // NEW: Handle query parameters for payment status to show toasts
  useEffect(() => {
    const params = new URLSearchParams(search);
    const status = params.get("status");
    const amount = params.get("amount");

    if (!status || hasShownToast.current) return; // NEW: Prevent duplicate toasts using hasShownToast

    hasShownToast.current = true; // NEW: Mark toast as shown

    switch (status) {
      case "success":
        showCustomToast(
          t("balanceRecharge.toastSuccess", { amount }),
          "success",
          <FaCheck />
        );
        // refreshServitor?.();
        silentRefresh();
        break;
      case "success-risk":
        showCustomToast(
          t("balanceRecharge.toastRisk"),
          "warning",
          <FaExclamationTriangle />
        );
        // refreshServitor?.();
        silentRefresh();
        break;
      case "cancelled":
        showCustomToast(
          t("balanceRecharge.toastCancelled"),
          "error",
          <FaTimesCircle />
        );
        break;
      case "failed":
        showCustomToast(
          t("balanceRecharge.toastFailed"),
          "error",
          <FaTimesCircle />
        );
        break;
      default:
        showCustomToast(
          t("balanceRecharge.toastError"),
          "error",
          <FaTimesCircle />
        );
    }

    // NEW: Clear query parameters to prevent toast re-firing on refresh
    params.delete("status");
    params.delete("amount");
    navigate({ pathname, search: params.toString() }, { replace: true });
  }, [search, pathname, navigate, t, refreshServitor, silentRefresh]);

  // Fetch metrics for accepted orders count
  useEffect(() => {
    if (servitor && servitor.Id) {
      fetch(`${URL}/servitor-dashboard-metrics/${servitor.Id}`)
        .then((res) => res.json())
        .then((metricsData) => {
          setMetrics(metricsData);
        })
        .catch((err) => console.error("Error fetching metrics:", err));

      // fetch(`http://localhost:4001/rewards/servitors/${servitor.Id}/summary`)
      //   .then((res) => res.json())
      //   .then((data) => {
      //     if (data && data.rewardPoints !== undefined) {
      //       setRewards({
      //         rewardPoints: data.rewardPoints,
      //         lifetimeRewardPoints: data.lifetimeRewardPoints,
      //         canClaim: data.canClaim,
      //         threshold: data.threshold,
      //       });
      //     }
      //   })
      //   .catch((err) => console.error("Error fetching rewards:", err));
    }
  }, [servitor]);

  // NEW: Listen for custom event to open balance modal
  useEffect(() => {
    const openModal = () => setShowBalanceModal(true);
    document.addEventListener("openBalanceModal", openModal);
    return () => document.removeEventListener("openBalanceModal", openModal);
  }, []);

  const togglePasswordModal = () => {
    setShowPasswordModal((prev) => !prev);
  };

  // NEW: Function to toggle balance modal
  const toggleBalanceModal = () => {
    setShowBalanceModal((prev) => !prev);
  };

  // Safely extract servitor fields with fallbacks
  const name = `${servitor?.FirstName || ""} ${
    servitor?.LastName || ""
  }`.trim();

  const SERVICE_KEY_MAP = {
    plumber: "plumber",
    electrician: "electrician",
    "home cleaning": "homeCleaning",
    "gas chula": "gasChula",
    "ac service": "acService",
     filter: "filter",
    "tutor service": "tutor",
  };
  // UPDATED: Normalize service value and add debugging for translation
  // const rawService = servitor?.service ? servitor.service.toLowerCase() : null;

  // // const service = servitor?.service || "";
  // console.log(
  //   "servitor.service:",
  //   servitor?.service,
  //   "normalized:",
  //   rawService
  // );
  // const service = rawService
  //   ? t(`viewOrderDetails.services.${rawService}.title`, {
  //       defaultValue: t("servitorProfile.unknownService"),
  //     }) // NEW: Translate service using viewOrderDetails.services with fallback to unknownService
  //   : t("servitorProfile.unknownService");

  // UPDATED: Normalize service value and add debugging for translation
  const rawService = servitor?.service ? servitor.service.toLowerCase() : null;
  // 2) map it to the JSON key (e.g. "home cleaning" → "homeCleaning")
  const serviceKey = rawService ? SERVICE_KEY_MAP[rawService] : null;

  let service;
  if (serviceKey) {
    // 3) look up the translated title, e.g. "Plumber Details"
    const fullTitle = t(`viewOrderDetails.services.${serviceKey}.name`, {
      defaultValue: t("servitorProfile.unknownService"),
    });
    // 4) strip any trailing " Details"
    service = fullTitle.replace(/\s*Details$/, "");
  } else {
    // fallback if we don’t recognize the string
    service = t("servitorProfile.unknownService");
  }

  // const status = servitor?.approve_status || "Pending";
  // const available = servitor?.availability || "busy";
  // const location = servitor?.city || "Unknown Location";
  // const address = servitor?.Address || "Unknown Address";

  const status = servitor?.approve_status || "Pending";
  const available = servitor?.availability || "busy";
  // const location = servitor?.city
  //   ? t(`servitorSite.cities.${servitor.city}`, {
  //       defaultValue: t("servitorProfile.unknownLocation"),
  //     })
  //   : t("servitorProfile.unknownLocation");

  const city = servitor?.city
    ? t(`servitorSite.cities.${servitor.city}`, {
        defaultValue: t("servitorProfile.unknownLocation"),
      })
    : t("servitorProfile.unknownLocation");
  const area =
    servitor?.area ||
    servitor?.Area ||
    servitor?.thana ||
    servitor?.Thana ||
    t("servitorProfile.unknownArea");

  const address = servitor?.Address || t("servitorProfile.unknownAddress");

  const rating = servitor?.rating || 0;
  // const reviewsCount = servitor?.rating_count || 0;
  const rewards = servitor?.reward_points || 0;
  const balance = servitor?.balance || 0;
  const completedJobs = servitor?.orders_completed || 0;
  const totalIncome = servitor?.total_earnings || 0;
  const acceptedOrders = metrics.totalAcceptedOrders || 0;
  // const targetOrders = 10;
  // Calculate completion rate as percentage of the target, capping at 100%
  // const completionRate =
  //   completedJobs > 0
  //     ? Math.min((completedJobs / targetOrders) * 100, 100).toFixed(0)
  //     : 0;
  // const responseTime = servitor?.responseTime || "~2 hours";
  const mobile = servitor?.mobile || "N/A";
  // const email = servitor?.email || "N/A";

  const nid =
    servitor?.NID || t("servitorProfile.unknownNID", { defaultValue: "N/A" });
  const experienceYears =
    servitor?.experience ||
    t("servitorProfile.noExperience", { defaultValue: "0 years" });

  //   const joinedDate = servitor?.created_at || "January 2024";

  // const joinedDate = servitor?.created_at
  //   ? new Date(servitor.created_at).toLocaleDateString("en-GB", {
  //       day: "2-digit",
  //       month: "long",
  //       year: "numeric",
  //     })
  //   : "January 2024";

  const locale = t("common.locale", { defaultValue: "en-GB" }); // NEW: Get locale from translations
  const validLocales = ["en-GB", "bn-BD"];
  const safeLocale = validLocales.includes(locale) ? locale : "en-GB"; // NEW: Ensure valid locale
  const joinedDate = servitor?.created_at
    ? new Date(servitor.created_at).toLocaleDateString(safeLocale, {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    : t("servitorProfile.defaultJoinDate");

  //   const servicesOffered = servitor?.services || [
  //     { name: "Home Cleaning", price: 200 },
  //     { name: "Deep Cleaning", price: 350 },
  //     { name: "Office Cleaning", price: 400 },
  //   ];

  //   const handleClaimRewards = async () => {
  //   if (!servitor?.Id) return;
  //   if (!rewards.canClaim) {
  //     showCustomToast(`You need at least ${rewards.threshold} points to claim.`, "warning", <FaExclamationTriangle />);
  //     return;
  //   }
  //   try {
  //     setClaimLoading(true);
  //     const res = await fetch(`http://localhost:4001/rewards/servitors/${servitor.Id}/claim`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //     });
  //     const data = await res.json();
  //     if (!res.ok) {
  //       showCustomToast(data?.message || "Claim failed", "error", <FaTimesCircle />);
  //     } else {
  //       const added = data.addedTaka || rewards.rewardPoints;
  //       showCustomToast(`Claimed ${added} tk from points`, "success", <FaCheck />);
  //       setRewards((r) => ({ ...r, rewardPoints: 0, canClaim: false }));
  //       // optionally bump balance in UI if you keep it here
  //     }
  //   } catch (e) {
  //     console.error(e);
  //     showCustomToast("Claim failed", "error", <FaTimesCircle />);
  //   } finally {
  //     setClaimLoading(false);
  //   }
  // };

  // ===== Reward banner calculations (CHANGED) =====
  // const points = Number(rewards.rewardPoints || 0);
  // const threshold = Number(rewards.threshold || 100);
  // const canClaimNow = points >= threshold; // only enable when ≥ 100
  // const progressPct = Math.min(100, Math.round((points / threshold) * 100));
  // const remaining = Math.max(0, threshold - points);

  // const handleClaimRewards = async () => {
  //   if (!servitor?.Id) return;
  //   if (!canClaimNow) {
  //     showCustomToast(
  //       `You need at least ${threshold} points to claim.`,
  //       "warning",
  //       <FaExclamationTriangle />
  //     );
  //     return;
  //   }
  //   try {
  //     setClaimLoading(true);
  //     const res = await fetch(
  //       `http://localhost:4001/rewards/servitors/${servitor.Id}/claim`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     );
  //     const data = await res.json();
  //     if (!res.ok) {
  //       showCustomToast(
  //         data?.message || "Claim failed",
  //         "error",
  //         <FaTimesCircle />
  //       );
  //     } else {
  //       const added = data.addedTaka || rewards.rewardPoints;
  //       showCustomToast(
  //         `Claimed ${added} tk from points`,
  //         "success",
  //         <FaCheck />
  //       );
  //       setRewards((r) => ({ ...r, rewardPoints: 0, canClaim: false }));
  //     }
  //   } catch (e) {
  //     console.error(e);
  //     showCustomToast("Claim failed", "error", <FaTimesCircle />);
  //   } finally {
  //     setClaimLoading(false);
  //   }
  // };

  return (
    <>
      <Toaster />
      <div className="servitorprofile-wrapper">
        <div className="servitorprofile-card">
          {/* Top Section with Avatar, Name, Status, Location */}
          <div className="servitorprofile-top-section">
            <img
              className="servitorprofile-avatar"
              src={
                servitor?.image
                  ? `${URL}/uploads/${servitor.image}`
                  : "https://via.placeholder.com/150"
              }
              alt="Profile"
            />
            <h2 className="servitorprofile-name">{name}</h2>
            {/* <p>Professional on {service} service</p> */}
            <p>{t("servitorProfile.professionalOnService", { service })}</p>

            <div className="servitorprofile-status-row">
              <span
                className={`servitorprofile-status-badge servitorprofile-status-${status.toLowerCase()}`}
                aria-label={t(`status.${status.toLowerCase()}`, {
                  defaultValue: status,
                })}
              >
                {/* {status} */}
                <i
                  className={`fas ${
                    status === "Approved"
                      ? "fa-check-circle"
                      : status === "Blocked"
                      ? "bx bxs-error-alt"
                      : "fa-hourglass-half"
                  }`}
                ></i>{" "}
                {/* {status} */}
                {t(`status.${status.toLowerCase()}`, { defaultValue: status })}
              </span>
              <span className="servitorprofile-location">
                <i className="fas fa-city"></i> {city}
              </span>
              <span className="servitorprofile-location">
                <i className="fas fa-map-marker-alt"></i> {area}
              </span>

              {/* <span
                className={`servitorprofile-status-badge servitorprofile-available-${available.toLowerCase()}`}
                aria-label={t(`status.${available.toLowerCase()}`, {
                  defaultValue: available,
                })}
              >
                <i
                  className={`fas ${
                    available === "available"
                      ? "fa-user-check"
                      : "fa-user-clock"
                  }`}
                ></i>{" "}
                {t(`status.${available.toLowerCase()}`, {
                  defaultValue: available,
                })}
              </span> */}
            </div>

            {/* <div className="servitorprofile-rating-row">
              <div className="servitorprofile-rating">
                <span className="servitorprofile-rating-stars">★</span>
                <span className="servitorprofile-rating-value">
                  {Number(rating).toFixed(2)}
                </span>
                <span className="servitorprofile-reviews-count">
                  {t("servitorProfile.reviews", { count: reviewsCount })}
                </span>
              </div>
            </div> */}

            <div className="servitorprofile-rating-row">
              <div className="servitorprofile-rating">
                <span className="servitorprofile-rating-stars">★</span>
                <span className="servitorprofile-rating-value">
                  {/* {rating.toFixed(1)} */}
                  {Number(rating).toFixed(2)}
                </span>
                {/* <span className="servitorprofile-reviews-count">
                  {t("servitorProfile.reviews", { count: reviewsCount })}
                </span> */}
              </div>

              <span
                className={`servitorprofile-status-badge servitorprofile-available-${available.toLowerCase()}`}
                aria-label={t(`status.${available.toLowerCase()}`, {
                  defaultValue: available,
                })}
              >
                <i
                  className={`fas ${
                    available === "available"
                      ? "fa-user-check"
                      : "fa-user-clock"
                  }`}
                ></i>{" "}
                {/* {available} */}
                {t(`status.${available.toLowerCase()}`, {
                  defaultValue: available,
                })}
              </span>

              {/* <span className="servitorprofile-reward-chip" title={t("reward.title", { defaultValue: "Rewards" })}>
                <FaTrophy className="servitorprofile-reward-chip-icon" />
                <span className="servitorprofile-reward-chip-text">
                  {rewards} {t("reward.pointsUnit", { defaultValue: "pts" })}
                </span>
              </span> */}

              <Link
                to="/servitor/servitor-rewards"
                className="servitorprofile-reward-chip servitorprofile-reward-link"
                aria-label={t("reward.title", { defaultValue: "Rewards" }) + `: ${rewards} ${t("reward.pointsUnit", { defaultValue: "pts" })}`}
              >
                <FaTrophy className="servitorprofile-reward-chip-icon" />
                <span className="servitorprofile-reward-chip-text">
                  {rewards} {t("reward.pointsUnit", { defaultValue: "pts" })}
                </span>
              </Link>


            </div>
          </div>

          {/* ===== CHANGED: NEW single-row Reward Banner placed AFTER top section ===== */}
          {/* <div className="sp-reward-banner">
            <div className="sp-reward-header">
              <div className="sp-reward-title-wrap">
                <FaGift className="sp-reward-gift-header" />
                <span>{t("reward.title")}</span>
              </div>
            </div>

            <div className="sp-reward-points-big">
              {points} {t("reward.pointsUnit")}
            </div>

            <div className="sp-reward-progress-section">
              <div className="sp-reward-progress-title">
                {t("reward.progress")}
              </div>

              <div className="sp-reward-progress-bar-container">
                <div className="sp-reward-progress-track">
                  <div
                    className="sp-reward-progress-fill"
                    style={{ width: `${progressPct}%` }}
                  />
                </div>
                <span className="sp-reward-progress-text">
                  {points}/{threshold}
                </span>
              </div>

              <div className="sp-reward-remaining">
                {remaining > 0
                  ? t("reward.needed", { remaining })
                  : t("reward.ready")}
              </div>
            </div>

            <button
              className={`sp-claim-button ${
                !canClaimNow || claimLoading ? "locked" : ""
              }`}
              disabled={!canClaimNow || claimLoading}
              onClick={handleClaimRewards}
              title={
                !canClaimNow
                  ? t("reward.requirementShort", { threshold })
                  : t("reward.claimNow")
              }
            >
              {!canClaimNow && <FaLock className="sp-claim-lock-icon" />}
              {claimLoading
                ? t("reward.claiming")
                : t("reward.claimCta", { threshold })}
            </button>
          </div> */}

          {/* ===== END Reward Banner ===== */}

          {/* MIDDLE SECTION (Cards + Contact Info) */}
          <div className="servitorprofile-middle-container">
            {/* Stats Cards Row */}
            <div className="servitorprofile-cards-row">
              <div className="servitorprofile-card-box">
                <div className="card-box-icon">
                  <FaMoneyBillWave />
                </div>
                <p className="card-box-value">{balance.toLocaleString()} Tk</p>
                {/* <p className="card-box-label">Balance</p> */}
                <p className="card-box-label">{t("servitorProfile.balance")}</p>
              </div>

              <div className="servitorprofile-card-box">
                <div className="card-box-icon">
                  <FaCheckCircle />
                </div>
                <p className="card-box-value">{completedJobs}</p>
                {/* <p className="card-box-label">Completed Jobs</p> */}
                <p className="card-box-label">
                  {t("servitorProfile.completedJobs")}
                </p>
              </div>

              <div className="servitorprofile-card-box">
                <div className="card-box-icon">
                  {/* <FaDollarSign /> */}
                  <span className="taka-icon">৳</span>
                </div>
                <p className="card-box-value">
                  {totalIncome.toLocaleString()} Tk
                </p>
                {/* <p className="card-box-label">Total Income</p> */}
                <p className="card-box-label">
                  {t("servitorProfile.totalIncome")}
                </p>
              </div>

              <div className="servitorprofile-card-box">
                <div className="card-box-icon">
                  <FaClipboardCheck />
                </div>
                <p className="card-box-value">{acceptedOrders}</p>
                {/* <p className="card-box-label">Accepted Orders</p> */}
                <p className="card-box-label">
                  {t("servitorProfile.acceptedOrders")}
                </p>
              </div>

              {/* <div className="servitorprofile-card-box">
                <div className="card-box-icon">
                  <FaClipboardCheck />
                </div>
                <p className="card-box-value">{rewards.rewardPoints} pts</p>
                <p className="card-box-label">Reward Points</p>
                <button
                  className="servitorprofile-btn"
                  style={{ marginTop: 8 }}
                  disabled={!rewards.canClaim || claimLoading}
                  onClick={handleClaimRewards}
                >
                  {claimLoading ? "Claiming..." : `Claim (≥ ${rewards.threshold})`}
                </button>
                <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
                  Lifetime: {rewards.lifetimeRewardPoints} pts
                </div>
              </div> */}
            </div>

            <ProfessionalBio servitor={servitor} />

            {/* Contact Info Card */}
            <div className="servitorprofile-contact-card">
              {/* <h3>Contact Information</h3> */}
              <h3>{t("servitorProfile.contactInformation")}</h3>
              <div className="servitor-contact-info-grid">
                <div className="servitor-contact-info-item">
                  <HiOutlinePhone className="servitor-contact-icon" />
                  <div className="servitor-contact-info-text">
                    {/* <span className="contact-info-label">Phone</span> */}
                    <span className="servitor-contact-info-label">
                      {t("servitorProfile.phone")}
                    </span>
                    <span className="servitor-contact-info-value">
                      {mobile}
                    </span>
                  </div>
                </div>
                {/* <div className="servitor-contact-info-item">
                  <AiOutlineMail className="servitor-contact-icon" />
                  <div className="servitor-contact-info-text">
                    <span className="servitor-contact-info-label">
                      {t("servitorProfile.email")}
                    </span>
                    <span className="servitor-contact-info-value">{email}</span>
                  </div>
                </div> */}

                <div className="servitor-contact-info-item">
                  <FaIdCard className="servitor-contact-icon" />
                  <div className="servitor-contact-info-text">
                    <span className="servitor-contact-info-label">
                      {t("servitorProfile.nid")}
                    </span>
                    <span className="servitor-contact-info-value">{nid}</span>
                  </div>
                </div>

                <div className="servitor-contact-info-item">
                  <FaBriefcase className="servitor-contact-icon" />
                  <div className="servitor-contact-info-text">
                    <span className="servitor-contact-info-label">
                      {t("servitorProfile.experienceYears")}
                    </span>
                    <span className="servitor-contact-info-value">
                      {experienceYears} {t("servitorProfile.years")}
                    </span>
                  </div>
                </div>

                <div className="servitor-contact-info-item">
                  <ImLocation2 className="servitor-contact-icon" />
                  <div className="servitor-contact-info-text">
                    {/* <span className="contact-info-label">Location</span> */}
                    <span className="servitor-contact-info-label">
                      {t("servitorProfile.location")}
                    </span>
                    <span className="servitor-contact-info-value">
                      {address}
                    </span>
                  </div>
                </div>
                <div className="servitor-contact-info-item">
                  <AiOutlineCalendar className="servitor-contact-icon" />
                  <div className="servitor-contact-info-text">
                    {/* <span className="contact-info-label">Member since</span> */}
                    <span className="servitor-contact-info-label">
                      {t("servitorProfile.memberSince")}
                    </span>
                    <span className="servitor-contact-info-value">
                      {joinedDate}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="servitorprofile-actions">
            {/* <button className="servitorprofile-btn">Edit Profile</button> */}

            {/* NEW: Added Recharge Balance button */}
            <button
              className="servitorprofile-btn"
              onClick={toggleBalanceModal}
              aria-label={t("balanceRecharge.title")}
            >
              <FaMoneyBillWave style={{ marginRight: "8px" }} />
              {t("balanceRecharge.title")}
            </button>

            <button
              className="servitorprofile-btn servitorprofile-btn-secondary"
              onClick={togglePasswordModal}
              aria-label={t("servitorProfile.changePassword")}
            >
              <FaLock style={{ marginRight: "8px" }} />
              {/* Change Password */}
              {t("servitorProfile.changePassword")}
            </button>
          </div>
        </div>

        <ChangePasswordModal
          isOpen={showPasswordModal}
          onClose={togglePasswordModal}
          servitorId={servitor?.Id}
        />

        {/* NEW: Added Balance Recharge Modal */}
        <BalanceRecharge
          isOpen={showBalanceModal}
          onClose={toggleBalanceModal}
          servitorId={servitor?.Id}
          currentBalance={servitor?.balance || 0}
          onBalanceUpdated={refreshServitor}
        />
      </div>
    </>
  );
};

export default ServitorProfile;
